import _ua from '../../plugins/is-ua.js';

class ScrollFixedContents {
  constructor(options) {
      
    const defaultOptions  = {
      fixedContainer : ".top-history",
      fixedTarget : ".top-history__inner",
      contentUnit : ".top-history-section",
      exUnit : ".top-history-flow__unit",
      isSP : 1024
    }
    
    this.options = this.mergedOptions(defaultOptions, options)
    
    this.inertiaScrollWrap = document.getElementById("js-inertiaScroll"),
    this.inertiaScrollFlag = !_ua().Mobile && !_ua().Tablet ? true : false,
    
    this.fixedContainer = document.querySelector(this.options.fixedContainer)

    if(!this.fixedContainer) return

    this.fixedTarget = document.querySelector(this.options.fixedTarget)
    this.contentUnits = [...document.querySelectorAll(this.options.contentUnit)]
    this.exUnits = [...document.querySelectorAll(this.options.exUnit)]

    this.unitLength = this.contentUnits.length

    this.windowHeight = window.innerHeight
    this.windowWidth = window.innerWidth
    this.fixedContainerHeight = this.fixedContainer.clientHeight

    this.scroll = 0
    this.scrollFixedY = 0

    this.currentIndex = 0

    this.scrollEvent = this.registerScrollEvent()
    this.resizeEvent = this.registerResizeEvent()

    this.click()
    this.inertiaScroll()
    this.setScrollY()
    // this.setCurrent()
  }

  mergedOptions(defaultOptions, options) {
    const mergedOptions = Object.assign(defaultOptions, options || {});
    return mergedOptions
  }

  registerScrollEvent() {
    let register = "";
    register = this.attachEvent(window, 'scroll', this.setCurrent.bind(this))
    register.addEvent();
    return register;
  }

  registerResizeEvent() {
    let register = "";
    register = this.attachEvent(window, 'resize', this.setContainerSize.bind(this))
    register.addEvent();
    return register;
  }

  setScrollY() {
    requestAnimationFrame(this.setScrollY.bind(this));

    // this.scroll += (this.getScrollY() - this.scroll) * 0.3;
    this.scrollFixedY = (Math.round(this.scroll * 100) / 100) - this.getFixedContainerPosition()
    // console.log(this.unitLength)

    let splitNumber = (this.fixedContainerHeight - this.windowHeight) / this.unitLength
    this.currentIndex = parseInt(this.scrollFixedY / splitNumber)

    // console.log(this.scrollFixedY < this.fixedContainerHeight - this.windowHeight)

    if(this.scrollFixedY < this.fixedContainerHeight - this.windowHeight) {
      const styles = {
        transform: this.scrollFixedY > 0 ? `translate3d(0px, ${this.scrollFixedY}px, 0px)` : 0
      };
      for (const key in styles) {
        this.fixedTarget.style[key] = this.options.isSP <= this.windowWidth ? styles[key] : "";
      }
    }

  }

  getFixedContainerPosition() {
    const clientRect = this.fixedContainer.getBoundingClientRect() ;
    const result = (Math.round(this.scroll * 100) / 100) + clientRect.top;
    return result
  }

  setCurrent() {    

    if(!(this.currentIndex < this.unitLength)) return

    this.contentUnits.forEach((target, index) => {
      target.classList.remove("is-show")
      this.exUnits[index].classList.remove("-current")
    });
    this.contentUnits.forEach((target, index) => {
      if(this.currentIndex == index && this.options.isSP <= this.windowWidth) {
        target.classList.add("is-show")
        this.exUnits[index].classList.add("-current")
        // console.log(this.exUnits[index])
      }
    });
  }

  setContainerSize() {
    this.windowWidth = window.innerWidth;
    this.fixedContainerHeight = this.fixedContainer.clientHeight
    this.setCurrent()
  }

  getScrollY() {
    if ('scrollY' in window) return window.scrollY;
    if ('pageYOffset' in window) return window.pageYOffset;

    const doc = window.document;

    return doc.compatMode === 'CSS1Compat' ? doc.documentElement.scrollTop : doc.body.scrollTop;
  }

  //慣性スクロール
  inertiaScroll() {
    if (this.inertiaScrollFlag || window.innerWidth >= this.options.isSP) {
      requestAnimationFrame(this.inertiaScroll.bind(this));

      document.body.style.height = this.inertiaScrollWrap.clientHeight + "px"

      this.inertiaScrollWrap.style.width = '100%'
      this.inertiaScrollWrap.style.position = 'fixed'

      this.scroll += (this.getScrollY() - this.scroll) * 0.3;

      this.inertiaScrollWrap.style.transform = `translate3d(0,${Math.round(-this.scroll * 100) / 100}px ,0)`
    }
  }

  click() {
    // document.querySelector(`[href="#link-history"]`).addEventListener("click", () => {
    //   setTimeout(() => {
    //     this.contentUnits.forEach((target, index) => {
    //       if(0 == index && this.options.isSP <= this.windowWidth) {
    //         target.classList.add("is-show")
    //         this.exUnits[index].classList.add("-current")
    //       }
    //     });
    //   },500)
    // })
  }

  attachEvent(element, type, listener, options) {
    return {
      addEvent() {
        element.addEventListener(type, listener, options);
      },
      removeEvent() {
        element.removeEventListener(type, listener);
      }
    }
  }

}

new ScrollFixedContents()







